import { FC } from "react";
import Heading from "../Typography/Heading";
import styles from "./PageHeading.module.scss";

const PageHeading: FC = ({ children }) => (
  <Heading className={styles["page-heading"]}>{children}</Heading>
);

export default PageHeading;
